import React, { useState } from 'react';
import PageContainer from 'modules/account/components/PageContainer/PageContainer';
import { useGetTemplate } from 'modules/account/configs/SchemaConfig';
import { HelpBox } from '../../../components/HelpBox/HelpBox';
import { pageConfigs } from '../../../configs/pageConfigs';
import { TwoFactorSendCodeComponent } from '../../../components/TwoFactorSendCodeComponent/TwoFactorSendCodeComponent';
import { OtpChannel } from '../../../_types/otp.types';
import { useOtpContext } from '../../../context/OtpContextProvider';
import { useOtpLogic } from '../../../hooks/useOtpLogic';
import {
  FactorValidationWrapper,
  SubtitleOtpRequest
} from '../ForgotPasswordOtpRequest/ForgotPasswordOtpRequest.styles';
import { useSchema } from '../../../hooks/useSchema';

export const OtpRequest: React.FC = () => {
  const {data: pageConfig = {}} = useGetTemplate(pageConfigs.otpRequest.template);
  const {selectedChannel, setSelectedChannel} = useOtpContext();
  const {
    displayUserData,
    isLoading,
    handleOtpRequest,
    determineSecurityCodeQuestion
  } = useOtpLogic();
  
  const {otpRequestChannelType} = useSchema()
  
  const [optionsCount, setOptionsCount] = useState<number>(0);
  
  const handleChannelSelect = (channel: OtpChannel) => {
    setSelectedChannel(channel);
  };
  
  const handleUpdateOptionsCount = (count: number) => {
    setOptionsCount(count);
  };
  
  return (
    <PageContainer
      title={pageConfig.title}
      navigateBack={pageConfigs.otpRequest.navigateBack()}
      buttonText={pageConfigs.otpRequest.buttonLabel}
      onClick={handleOtpRequest}
      loading={isLoading}
      extraAboveButton={<HelpBox/>}
      thereIsButton
    >
      <SubtitleOtpRequest>
        {determineSecurityCodeQuestion(optionsCount)}
      </SubtitleOtpRequest>
      
      {displayUserData && (
        <FactorValidationWrapper>
          <TwoFactorSendCodeComponent
            otpRequestChannelType={otpRequestChannelType}
            userData={{
              phoneNumber: displayUserData.phoneNumber,
              email: displayUserData.email
            }}
            onChannelSelect={handleChannelSelect}
            selectedChannel={selectedChannel}
            updateOptionsCount={handleUpdateOptionsCount}
          />
        </FactorValidationWrapper>
      )}
    </PageContainer>
  );
};
